angular.module('rjmNg.directives').directive "pagination", [
  () ->
    restrict: 'E'
    replace: true
    templateUrl: "directive.pagination.html"
    scope:
      pageNumber: "="
      list: "="
      limit: "="
    link: (scope, elem, attrs) ->
      scope.maxPagesToDisplay = 10
      scope.firstPageToDisplay = 0
      scope.lastPageToDisplay = 0

      scope.shouldDisplayPage = (pageNum) ->
        return (scope.firstPageToDisplay == 0 || scope.firstPageToDisplay <= pageNum) && (scope.lastPageToDisplay == 0 || scope.lastPageToDisplay >= pageNum)

      scope.limitDisplayedPages = ->
        if scope.maxPage <= scope.maxPagesToDisplay
          scope.firstPageToDisplay = scope.lastPageToDisplay = 0
          return

        offsetPagesToDisplay = Math.floor(scope.maxPagesToDisplay/2)
        scope.firstPageToDisplay = Math.max(1, scope.pageNumber - offsetPagesToDisplay)
        scope.lastPageToDisplay = Math.min(scope.maxPage, scope.pageNumber + offsetPagesToDisplay)

      scope.setPage = (page) ->
        scope.pageNumber = page

      scope.incrementPage = ->
        if (scope.pageNumber + 1) <= scope.maxPage
          scope.pageNumber = scope.pageNumber + 1

      scope.decrementPage = ->
        if (scope.pageNumber - 1) >= 1
          scope.pageNumber = scope.pageNumber - 1

      scope.limitDisplayedPages()

      scope.$watch('pageNumber', ->
        scope.limitDisplayedPages()
      )

      scope.$watch('list', ->
        scope.list = scope.list || []

        scope.maxPage = Math.ceil(scope.list.length / scope.limit)
        scope.pages = _.range(1, scope.maxPage+1)

        scope.limitDisplayedPages()
      )
]
